import {ApiUserProfile} from './api/auth';
import {isUpstreamInternalOrgUser} from './userUtils';

// Org IDs for adding csv upload functionality
const SCE_ORG_ID = '5dd9bf55-d526-4a2d-b220-5f085ff2c354';
const TRI_DAM_ORG_ID = 'c59c4c4c-0508-4752-abbd-daea1e5ebe66';
const FREEPORT_MCMORAN_ORG_ID = '532956ea-1b50-46d1-8b31-8a415462d274';
const XCEL_ORG_ID = 'd3e90e0e-833a-4dd1-8f90-720c99b79dd4';
const CSV_UPLOAD_ORG_IDS = [SCE_ORG_ID, TRI_DAM_ORG_ID, FREEPORT_MCMORAN_ORG_ID, XCEL_ORG_ID];

export default {
  ST3_VERSION_TAG: false, // depends on USE_API_MOCKING for projects
  USE_API_MOCKING: false,
  OBSERVATIONS_UPLOAD: (profile: ApiUserProfile | null) =>
    isUpstreamInternalOrgUser(profile) ||
    (profile && CSV_UPLOAD_ORG_IDS.includes(profile.organizationKey)),
  STAGING_TOGGLE: (profile: ApiUserProfile | null) => isUpstreamInternalOrgUser(profile),
  H5_PREVIEW: (profile: ApiUserProfile | null) => isUpstreamInternalOrgUser(profile),
  EVAL_DASHBOARD: (profile: ApiUserProfile | null) => isUpstreamInternalOrgUser(profile),
  SETUP_WIZARD: (profile: ApiUserProfile | null) => isUpstreamInternalOrgUser(profile),
  REGIONAL_REPORT: (profile: ApiUserProfile | null) => isUpstreamInternalOrgUser(profile),
  // Read GFS/GEFS/HRRR forecasts directly from dynamical.org icechunk stores
  // instead of the HF API; see src/lib/dynamical/. Off for everyone while we
  // gather shadow-comparison telemetry first (DYNAMICAL_SHADOW_COMPARISON);
  // force-enable per session with `localStorage hfw.dynamicalDirectWeather=on`
  // to dogfood the live path.
  DYNAMICAL_DIRECT_WEATHER: (_profile: ApiUserProfile | null) => false,
  // Shadow mode: keep serving the HF API, but in the background also read the
  // same query from dynamical.org and record a parity metric to PostHog so we
  // can measure the direct path's production accuracy before it goes live.
  // Only fires when DYNAMICAL_DIRECT_WEATHER is off (live reads already prove
  // themselves via the API fallback). This gate is the always-on audience
  // (internal users); flag.ts additionally samples a slice of other sessions.
  // See src/lib/dynamical/shadowCompare.ts.
  DYNAMICAL_SHADOW_COMPARISON: (profile: ApiUserProfile | null) =>
    isUpstreamInternalOrgUser(profile),
};
